import { RadioGroup } from '@/components/RadioGroup';
import {
    selectNumberOfChildren,
    setNumberOfChildren,
} from '@/context/borrower';
import { useAppDispatch, useAppSelector } from '@/context/storeHooks';
import { useFieldCopy } from '@/copy';
import { getNumber } from '@/utils/valueFormat';

export interface IProps {
    baseId: string;
    showErrors: boolean;
}

export const testId = 'NumberOfKids';

export function NumberOfKids({ baseId, showErrors }: IProps): JSX.Element {
    // ***** Redux *****
    const fields = useFieldCopy();
    const numberOfChildren = useAppSelector(selectNumberOfChildren);
    const dispatch = useAppDispatch();

    // ***** Event Handlers *****
    function handleChange(value: string | boolean | undefined): void {
        if (!value) return;
        // MAXIMUM
        const intValue = getNumber(value);
        if (intValue === numberOfChildren) return;
        dispatch(setNumberOfChildren(intValue));
    }

    // ***** Render *****
    const options = [
        {
            label: '1',
            value: '1',
            id: `${baseId}-button-numberOfKids-1`,
        },
        {
            label: '2',
            value: '2',
            id: `${baseId}-button-numberOfKids-2`,
        },
        {
            label: '3+',
            value: '3',
            id: `${baseId}-button-numberOfKids-3+`,
        },
    ];

    // ***** Render *****
    return (
        <div data-testid={testId}>
            <RadioGroup
                title={fields.numberOfKids}
                showErrors={showErrors}
                onChange={handleChange}
                options={options}
                value={`${numberOfChildren}`}
                // No tooltip: this is the follow-up to a question that has
                // already defined who counts, so a second icon saying the
                // same thing is one more thing to tap and dismiss.
            />
        </div>
    );
}
